import { render, staticRenderFns } from "./PxFooter.vue?vue&type=template&id=9bd11ed0&lang=pug&"
import script from "./PxFooter.vue?vue&type=script&lang=js&"
export * from "./PxFooter.vue?vue&type=script&lang=js&"
import style0 from "./PxFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports